export default __webpack_public_path__ + "static/media/stats-preview.8ded4bc2.png";